import { ref } from 'vue';
import type { CategoryMM, PromoCategoryMM } from '~/entities/category';
import { mapCategory, mapPromoCategory } from './categoryMapper';
import type { CategoriesService } from '~/shared/api/ke-gateway/categories';
import type { TCategoriesTrackerPayload } from '../models/tracker';

export class DataManager {
  private client: CategoriesService;
  public _trackerPayload: TCategoriesTrackerPayload = {};

  constructor(client: CategoriesService) {
    this.client = client;
  }

  public isCategoriesLoaded = ref(false);
  public isLoading = ref(false);
  public rootCategories = ref<CategoryMM[]>([]);
  public promoCategories = ref<PromoCategoryMM[]>([]);

  private async fetchRootCategories(): Promise<CategoryMM[]> {
    const response = await this.client.getRootCategories();
    return response.payload.map(mapCategory);
  }

  private async fetchPromoCategories(): Promise<PromoCategoryMM[]> {
    const response = await this.client.getPromoCategories();
    return response.payload.map(mapPromoCategory);
  }

  public async fetchCategories(): Promise<void> {
    this.isLoading.value = true;
    const rootCategories = await this.fetchRootCategories();
    const promoCategories = await this.fetchPromoCategories();

    this.rootCategories.value = rootCategories;
    this.promoCategories.value = promoCategories;

    this.isLoading.value = false;
    this.isCategoriesLoaded.value = true;

    this.fillTrackerPayload();
  }

  private fillTrackerPayload() {
    this._trackerPayload = {
      category_list: this.rootCategories.value.map((it) => it.title).join(', '),
    };
  }
}
